var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutCoreIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.152 20.75H16.4967C16.1877 21.6245 15.3545 22.25 14.375 22.25C13.1323 22.25 12.125 21.2428 12.125 20C12.125 18.7572 13.1323 17.75 14.375 17.75C15.3545 17.75 16.1885 18.3763 16.4975 19.25H18.152L20.75 14.75H23.1275C23.4365 13.8763 24.2705 13.25 25.25 13.25C26.4928 13.25 27.5 14.2573 27.5 15.5C27.5 16.7427 26.4928 17.75 25.25 17.75C24.2705 17.75 23.4372 17.1245 23.1283 16.25H21.6155L19.451 19.9992L21.6163 23.75H23.1283C23.4365 22.8763 24.2705 22.25 25.25 22.25C26.4928 22.25 27.5 23.2572 27.5 24.5C27.5 25.7428 26.4928 26.75 25.25 26.75C24.2705 26.75 23.4372 26.1245 23.1283 25.25H20.75L18.152 20.75ZM25.25 23.75C24.836 23.75 24.5 24.086 24.5 24.5C24.5 24.914 24.836 25.25 25.25 25.25C25.664 25.25 26 24.914 26 24.5C26 24.086 25.664 23.75 25.25 23.75ZM14.375 19.25C13.961 19.25 13.625 19.586 13.625 20C13.625 20.414 13.961 20.75 14.375 20.75C14.789 20.75 15.125 20.414 15.125 20C15.125 19.586 14.789 19.25 14.375 19.25ZM25.25 14.75C24.836 14.75 24.5 15.086 24.5 15.5C24.5 15.914 24.836 16.25 25.25 16.25C25.664 16.25 26 15.914 26 15.5C26 15.086 25.664 14.75 25.25 14.75Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCoreIcon5);
export default __webpack_public_path__ + "static/media/about_core_icon5.2470812b5bf7e1f7607d4ed25c4656d6.svg";
export { ForwardRef as ReactComponent };